import { useQuery } from '@tanstack/react-query';
import BreadcrumbsComponent from 'components/BreadcrumbsComponent';
import DetailModuleSection from 'modules/pages/dacum/moduleManagement/DetailModuleSection';
import LoaderModuleSection from 'modules/pages/dacum/moduleManagement/LoaderModuleSection';
import React from 'react';
import { useParams } from 'react-router-dom';
import { pathnames } from 'routes/dacum';
import { moduleManagementService } from 'services/dacum/module.service';

const DetailModuleManagementPage = () => {
  const params = useParams();
  const { id } = params;

  const { data, isLoading } = useQuery({
    queryKey: ['moduleManagementDetail', id],
    queryFn: () => moduleManagementService.detailModule(id as string),
    enabled: !!id,
    select: (response) => response.data
  });

  const breadcrumbs = [
    { title: 'Competency Module Management', href: pathnames.competencyModule },
    { title: 'Detail Module', href: '' }
  ];

  return (
    <>
      <BreadcrumbsComponent items={breadcrumbs} mb={32} />

      {isLoading && <LoaderModuleSection />}

      {!isLoading && data && <DetailModuleSection data={data} />}
    </>
  );
};

export default DetailModuleManagementPage;
